import React, { useState, useRef, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import RoomIcon from "@mui/icons-material/Room";
import CheckBox from "shared/components/FormElements/CheckBox";

import { useForm } from "shared/hooks/form-hook";
import { VALIDATOR_NONE } from "shared/util/validators";

import Marker from "shared/components/UIElements/Marker";
import CustomSelect from "shared/components/FormElements/Select";
import Input from "shared/components/FormElements/Input";

// #region Hooks
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
// #endregion Hooks

const WalkingDistanceCalculator = () => {
  const circlesRef = useRef([]);
  const [showNames, setShowNames] = useState(true);
  const myLocations = [
    {
      name: "1 NOLU ASM",
      lat: 39.92930547,
      lng: 32.84484754,
    },
    {
      name: "2 NOLU ASM",
      lat: 39.92190685,
      lng: 32.84982647,
    },
    {
      name: "3 NOLU ASM",
      lat: 39.91481332781556,
      lng: 32.86883841814833,
    },
    {
      name: "4 NOLU ASM",
      lat: 39.89410336,
      lng: 32.88078753,
    },
    {
      name: "5 NOLU ASM",
      lat: 39.93499737,
      lng: 32.88621256,
    },
    {
      name: "6 NOLU ASM",
      lat: 39.92624666,
      lng: 32.86734391,
    },
    {
      name: "7 NOLU ASM",
      lat: 39.91347238,
      lng: 32.81588316,
    },
    {
      name: "100. YIL ASM",
      lat: 39.89423916,
      lng: 32.79467685,
    },
    {
      name: "AŞAĞI AYRANCI ASM",
      lat: 39.90006094,
      lng: 32.85164298,
    },
    {
      name: "AHMET HAŞİM ASM",
      lat: 39.88710315,
      lng: 32.83364673,
    },
    {
      name: "AŞIKPAŞA ASM",
      lat: 39.90648903,
      lng: 32.88089127,
    },
    {
      name: "ATA ASM",
      lat: 39.87811724,
      lng: 32.82351128,
    },
    {
      name: "ATAKULE ASM",
      lat: 39.88636652,
      lng: 32.85443381,
    },
    {
      name: "BAĞLAR ASM",
      lat: 39.89962183,
      lng: 32.87530259,
    },
    {
      name: "BAHÇELİEVLER ASM",
      lat: 39.92681985,
      lng: 32.82985391,
    },
    {
      name: "BARBAROS ASM",
      lat: 39.87286789,
      lng: 32.85692295,
    },
    {
      name: "BESTEKAR ASM",
      lat: 39.91113438,
      lng: 32.85791073,
    },
    {
      name: "BEYTEPE ASM",
      lat: 39.86184905,
      lng: 32.71421769,
    },
    {
      name: "CEBECİ ASM",
      lat: 39.93026249,
      lng: 32.87408468,
    },
    {
      name: "CEVİZLİDERE ASM",
      lat: 39.8811019,
      lng: 32.8140253,
    },
    {
      name: "ÇUKURAMBAR ASM",
      lat: 39.9064774,
      lng: 32.80381883,
    },
    {
      name: "ÇUKURCA ASM",
      lat: 39.88333766,
      lng: 32.87589783,
    },
    {
      name: "DİKMEN AKPINAR ASM",
      lat: 39.86366049,
      lng: 32.81827717,
    },
    {
      name: "EHLİBEYT ASM",
      lat: 39.88571492,
      lng: 32.81922771,
    },
    {
      name: "EMEK ASM",
      lat: 39.92439368,
      lng: 32.81599,
    },
    {
      name: "ERDOĞAN ŞAHİNOĞLU ASM",
      lat: 39.88016087,
      lng: 32.80024951,
    },
    {
      name: "G.O.P ASM",
      lat: 39.89681952,
      lng: 32.87116027,
    },
    {
      name: "HİLAL ASM",
      lat: 39.8704395,
      lng: 32.86299865,
    },
    {
      name: "HOŞDERE ASM",
      lat: 39.89930339,
      lng: 32.84851933,
    },
    {
      name: "HÜRRİYET ASM",
      lat: 39.88652817,
      lng: 32.8387533,
    },
    {
      name: "İNCESU ASM",
      lat: 39.91867461,
      lng: 32.86875421,
    },
    {
      name: "KARAPINAR ASM",
      lat: 39.86871079,
      lng: 32.82006584,
    },
    {
      name: "KEKLİKPINARI ASM",
      lat: 39.85952951,
      lng: 32.81750551,
    },
    {
      name: "KERKÜK ASM",
      lat: 39.89143443,
      lng: 32.87535737,
    },
    {
      name: "KIRIM ASM",
      lat: 39.92505861,
      lng: 32.8157595,
    },
    {
      name: "KIRKKONAKLAR ASM",
      lat: 39.88104825,
      lng: 32.88687656,
    },
    {
      name: "MALTEPE ASM",
      lat: 39.9240901,
      lng: 32.84423087,
    },
    {
      name: "MEŞRUTİYET ASM",
      lat: 39.91944234,
      lng: 32.861325,
    },
    {
      name: "MİSAK-I MİLLİ ASM",
      lat: 39.9025079,
      lng: 32.84595768,
    },
    {
      name: "MUSTAFA KEMAL ASM",
      lat: 39.91188918,
      lng: 32.75979237,
    },
    {
      name: "MUTLUKENT  ASM",
      lat: 39.88901685,
      lng: 32.71760164,
    },
    {
      name: "MÜRSEL ULUÇ ASM",
      lat: 39.85837855,
      lng: 32.83085353,
    },
    {
      name: "OSMAN TEMİZ MAH.ASM",
      lat: 39.87478388,
      lng: 32.84005217,
    },
    {
      name: "ORAN 75. YIL ASM",
      lat: 39.84879687,
      lng: 32.8230781,
    },
    {
      name: "ÖVEÇLER DİLHAN ASM",
      lat: 39.88487209,
      lng: 32.82761517,
    },
    {
      name: "SOKULLU MEHMET PAŞA ASM",
      lat: 39.88294826,
      lng: 32.83193844,
    },
    {
      name: "ŞAHİN ASM",
      lat: 39.9302938,
      lng: 32.8787301,
    },
    {
      name: "ŞEHİT ALAATTİN YAKUP SARAÇOĞLU",
      lat: 39.89232992,
      lng: 32.83836736,
    },
    {
      name: "ŞEMSETTİN GÜNALTAY ASM",
      lat: 39.90455273,
      lng: 32.88390508,
    },
    {
      name: "TINAZTEPE ASM",
      lat: 39.91233262,
      lng: 32.86917493,
    },
    {
      name: "YAKUPABDAL ASM",
      lat: 39.83242801,
      lng: 32.94627547,
    },
    {
      name: "ÇAYYOLU 1 NOLU ASM",
      lat: 39.88558949,
      lng: 32.69849824,
    },
    {
      name: "ÇAYYOLU 2 NOLU ASM",
      lat: 39.88657838,
      lng: 32.68160557,
    },
    {
      name: "ÇAYYOLU 3 NOLU ASM",
      lat: 39.90247393,
      lng: 32.69566273,
    },
    {
      name: "KEZBAN HÜSEYİN MERCAN ASM",
      lat: 39.87066939,
      lng: 32.66508034,
    },
    {
      name: "ALACAATLI ASM",
      lat: 39.8465749,
      lng: 32.67373958,
    },
    {
      name: "SEVGİ ASM",
      lat: 39.88800204,
      lng: 32.88834304,
    },
    {
      name: "YAŞAMKENT  ASM",
      lat: 39.85886097,
      lng: 32.65065233,
    },
    {
      name: "9 NOLU ASM",
      lat: 39.86186552,
      lng: 32.71421769,
    },
    {
      name: "ESAT ASM",
      lat: 39.90810176,
      lng: 32.86769025,
    },
    {
      name: "10 NOLU ASM",
      lat: 39.89014404,
      lng: 32.82841771,
    },
    {
      name: "İLKBAHAR ASM",
      lat: 39.8486749,
      lng: 32.85610793,
    },
    {
      name: "ÇINAR ASM",
      lat: 39.88330646,
      lng: 32.84902227,
    },
    {
      name: "ANIT ASM",
      lat: 39.92251509,
      lng: 32.83232849,
    },
    {
      name: "DODURGA ASM",
      lat: 39.83068583,
      lng: 32.66171288,
    },
    {
      name: "AHLATLIBEL ASM",
      lat: 39.83312779,
      lng: 32.74160951,
    },
    {
      name: "EĞİTİM ASM",
      lat: 39.89343103,
      lng: 32.71350174,
    },
  ];

  const cankaya = [
    { lat: 39.924135, lng: 32.768951 },
    { lat: 39.923721, lng: 32.775637 },
    { lat: 39.923607, lng: 32.77576 },
    { lat: 39.922227, lng: 32.776824 },
    { lat: 39.924293, lng: 32.800276 },
    { lat: 39.922702, lng: 32.800575 },
    { lat: 39.917822, lng: 32.80214 },
    { lat: 39.912797, lng: 32.805531 },
    { lat: 39.911525, lng: 32.809661 },
    { lat: 39.914362, lng: 32.812547 },
    { lat: 39.920182, lng: 32.813622 },
    { lat: 39.926272, lng: 32.815337 },
    { lat: 39.930462, lng: 32.820118 },
    { lat: 39.937959, lng: 32.838232 },
    { lat: 39.931963, lng: 32.846423 },
    { lat: 39.927744, lng: 32.849998 },
    { lat: 39.926675, lng: 32.855172 },
    { lat: 39.927556, lng: 32.862229 },
    { lat: 39.929119, lng: 32.870055 },
    { lat: 39.93075, lng: 32.875352 },
    { lat: 39.931376, lng: 32.876853 },
    { lat: 39.930823, lng: 32.877354 },
    { lat: 39.927932, lng: 32.878566 },
    { lat: 39.921552, lng: 32.879657 },
    { lat: 39.913817, lng: 32.88158 },
    { lat: 39.908517, lng: 32.886008 },
    { lat: 39.905907, lng: 32.892087 },
    { lat: 39.902177, lng: 32.898414 },
    { lat: 39.895999, lng: 32.902626 },
    { lat: 39.889022, lng: 32.90291 },
    { lat: 39.881929, lng: 32.903989 },
    { lat: 39.876627, lng: 32.910262 },
    { lat: 39.874855, lng: 32.918035 },
    { lat: 39.87494, lng: 32.92398 },
    { lat: 39.874896, lng: 32.928763 },
    { lat: 39.87423, lng: 32.932713 },
    { lat: 39.872654, lng: 32.936632 },
    { lat: 39.870013, lng: 32.941738 },
    { lat: 39.866513, lng: 32.9468 },
    { lat: 39.86156, lng: 32.94891 },
    { lat: 39.854404, lng: 32.949241 },
    { lat: 39.846863, lng: 32.952861 },
    { lat: 39.842301, lng: 32.95944 },
    { lat: 39.83943, lng: 32.964415 },
    { lat: 39.834499, lng: 32.968579 },
    { lat: 39.829882, lng: 32.974354 },
    { lat: 39.828116, lng: 32.980093 },
    { lat: 39.826044, lng: 32.984899 },
    { lat: 39.821837, lng: 32.988977 },
    { lat: 39.81673, lng: 32.991194 },
    { lat: 39.810799, lng: 32.991144 },
    { lat: 39.804024, lng: 32.989144 },
    { lat: 39.797772, lng: 32.987268 },
    { lat: 39.79305, lng: 32.987903 },
    { lat: 39.790282, lng: 32.990882 },
    { lat: 39.789123, lng: 32.996084 },
    { lat: 39.789237, lng: 33.001931 },
    { lat: 39.790993, lng: 33.005673 },
    { lat: 39.793447, lng: 33.00886 },
    { lat: 39.799568, lng: 33.023949 },
    { lat: 39.79951, lng: 33.024441 },
    { lat: 39.799138, lng: 33.026457 },
    { lat: 39.797658, lng: 33.029968 },
    { lat: 39.794686, lng: 33.034414 },
    { lat: 39.791675, lng: 33.039673 },
    { lat: 39.789867, lng: 33.044326 },
    { lat: 39.789112, lng: 33.047668 },
    { lat: 39.789067, lng: 33.051804 },
    { lat: 39.788805, lng: 33.058055 },
    { lat: 39.789118, lng: 33.064813 },
    { lat: 39.791198, lng: 33.071206 },
    { lat: 39.791202, lng: 33.077427 },
    { lat: 39.785432, lng: 33.082382 },
    { lat: 39.776959, lng: 33.086429 },
    { lat: 39.771329, lng: 33.089769 },
    { lat: 39.769221, lng: 33.091445 },
    { lat: 39.766909, lng: 33.093873 },
    { lat: 39.763296, lng: 33.100594 },
    { lat: 39.760527, lng: 33.110079 },
    { lat: 39.759594, lng: 33.118759 },
    { lat: 39.759056, lng: 33.127599 },
    { lat: 39.755266, lng: 33.135487 },
    { lat: 39.748627, lng: 33.136345 },
    { lat: 39.744297, lng: 33.129794 },
    { lat: 39.741791, lng: 33.121776 },
    { lat: 39.725696, lng: 33.112632 },
    { lat: 39.723286, lng: 33.095211 },
    { lat: 39.72128, lng: 33.087962 },
    { lat: 39.721338, lng: 33.080227 },
    { lat: 39.721413, lng: 33.073124 },
    { lat: 39.718983, lng: 33.068693 },
    { lat: 39.714546, lng: 33.066459 },
    { lat: 39.709337, lng: 33.066654 },
    { lat: 39.704894, lng: 33.067947 },
    { lat: 39.701495, lng: 33.067158 },
    { lat: 39.698319, lng: 33.063565 },
    { lat: 39.694835, lng: 33.059092 },
    { lat: 39.690822, lng: 33.056802 },
    { lat: 39.686801, lng: 33.057891 },
    { lat: 39.68349, lng: 33.059794 },
    { lat: 39.67991, lng: 33.059116 },
    { lat: 39.675272, lng: 33.055234 },
    { lat: 39.671907, lng: 33.050208 },
    { lat: 39.6709, lng: 33.045713 },
    { lat: 39.670435, lng: 33.042344 },
    { lat: 39.669563, lng: 33.040418 },
    { lat: 39.667684, lng: 33.038748 },
    { lat: 39.664517, lng: 33.035506 },
    { lat: 39.662664, lng: 33.030545 },
    { lat: 39.664384, lng: 33.025742 },
    { lat: 39.667239, lng: 33.021584 },
    { lat: 39.669408, lng: 33.01615 },
    { lat: 39.673006, lng: 33.010378 },
    { lat: 39.677873, lng: 33.006539 },
    { lat: 39.6822, lng: 33.002566 },
    { lat: 39.686437, lng: 32.995933 },
    { lat: 39.689525, lng: 32.98895 },
    { lat: 39.690216, lng: 32.984479 },
    { lat: 39.690121, lng: 32.981681 },
    { lat: 39.690983, lng: 32.978097 },
    { lat: 39.694137, lng: 32.973004 },
    { lat: 39.699636, lng: 32.968585 },
    { lat: 39.704882, lng: 32.964755 },
    { lat: 39.707468, lng: 32.958409 },
    { lat: 39.708887, lng: 32.950227 },
    { lat: 39.711893, lng: 32.944429 },
    { lat: 39.716477, lng: 32.942646 },
    { lat: 39.721529, lng: 32.941188 },
    { lat: 39.72565, lng: 32.936056 },
    { lat: 39.727271, lng: 32.928614 },
    { lat: 39.726996, lng: 32.921698 },
    { lat: 39.726825, lng: 32.9157 },
    { lat: 39.72849, lng: 32.910435 },
    { lat: 39.731943, lng: 32.906013 },
    { lat: 39.734578, lng: 32.903258 },
    { lat: 39.735264, lng: 32.902485 },
    { lat: 39.73655, lng: 32.902286 },
    { lat: 39.740438, lng: 32.901749 },
    { lat: 39.744655, lng: 32.902323 },
    { lat: 39.747504, lng: 32.906074 },
    { lat: 39.750408, lng: 32.91195 },
    { lat: 39.753399, lng: 32.917581 },
    { lat: 39.755874, lng: 32.922439 },
    { lat: 39.758708, lng: 32.926725 },
    { lat: 39.7644, lng: 32.931207 },
    { lat: 39.773285, lng: 32.93459 },
    { lat: 39.780253, lng: 32.934341 },
    { lat: 39.783767, lng: 32.931188 },
    { lat: 39.78779, lng: 32.926384 },
    { lat: 39.791089, lng: 32.920307 },
    { lat: 39.790647, lng: 32.913715 },
    { lat: 39.790296, lng: 32.907868 },
    { lat: 39.794169, lng: 32.902987 },
    { lat: 39.800627, lng: 32.897813 },
    { lat: 39.806566, lng: 32.892452 },
    { lat: 39.810298, lng: 32.887114 },
    { lat: 39.811345, lng: 32.882019 },
    { lat: 39.810254, lng: 32.877959 },
    { lat: 39.808633, lng: 32.873281 },
    { lat: 39.808635, lng: 32.866585 },
    { lat: 39.810607, lng: 32.860435 },
    { lat: 39.813295, lng: 32.854311 },
    { lat: 39.815336, lng: 32.845028 },
    { lat: 39.815773, lng: 32.836542 },
    { lat: 39.815948, lng: 32.830796 },
    { lat: 39.816547, lng: 32.822611 },
    { lat: 39.815141, lng: 32.812211 },
    { lat: 39.813442, lng: 32.803906 },
    { lat: 39.815805, lng: 32.799106 },
    { lat: 39.821708, lng: 32.796655 },
    { lat: 39.828199, lng: 32.793358 },
    { lat: 39.8328, lng: 32.787967 },
    { lat: 39.835476, lng: 32.780864 },
    { lat: 39.835764, lng: 32.771616 },
    { lat: 39.83189, lng: 32.763019 },
    { lat: 39.827771, lng: 32.757578 },
    { lat: 39.827403, lng: 32.751313 },
    { lat: 39.828439, lng: 32.741422 },
    { lat: 39.829024, lng: 32.733175 },
    { lat: 39.830518, lng: 32.729319 },
    { lat: 39.832423, lng: 32.724328 },
    { lat: 39.831522, lng: 32.716364 },
    { lat: 39.827504, lng: 32.704961 },
    { lat: 39.829034, lng: 32.704354 },
    { lat: 39.83394, lng: 32.701292 },
    { lat: 39.839521, lng: 32.695732 },
    { lat: 39.843792, lng: 32.691889 },
    { lat: 39.849496, lng: 32.69362 },
    { lat: 39.856559, lng: 32.699838 },
    { lat: 39.862923, lng: 32.705641 },
    { lat: 39.868309, lng: 32.707872 },
    { lat: 39.873399, lng: 32.708182 },
    { lat: 39.879178, lng: 32.707781 },
    { lat: 39.885012, lng: 32.705465 },
    { lat: 39.890255, lng: 32.703207 },
    { lat: 39.896277, lng: 32.703969 },
    { lat: 39.903517, lng: 32.706284 },
    { lat: 39.909013, lng: 32.709087 },
    { lat: 39.910607, lng: 32.714059 },
    { lat: 39.910286, lng: 32.720859 },
    { lat: 39.909019, lng: 32.727991 },
    { lat: 39.906076, lng: 32.735341 },
    { lat: 39.904927, lng: 32.742803 },
    { lat: 39.908031, lng: 32.749763 },
    { lat: 39.924135, lng: 32.768951 },
  ];

  const myDistances = [
    {
      value: 420,
      label: "5 min",
    },
    {
      value: 840,
      label: "10 min",
    },
    {
      value: 1260,
      label: "15 min",
    },
    {
      value: 1680,
      label: "20 min",
    },
    {
      value: 2100,
      label: "25 min",
    },
    {
      value: 2520,
      label: "30 min",
    },
  ];

  const [formState, inputHandler] = useForm(
    {
      selectedDistance: {
        value: 420,
        isValid: true,
      },
      showNames: {
        value: true,
        isValid: true,
      },
    },
    true
  );

  const mapREF = useRef(null);
  const mapsREF = useRef(null);

  const drawCircles = (locations, radius) => {
    if (!mapREF.current || !mapsREF.current) return;

    circlesRef.current.forEach((circle) => circle.setMap(null));
    circlesRef.current = [];

    locations.forEach((loc) => {
      const circle = new mapsREF.current.Circle({
        strokeColor: "#007bff",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#007bff",
        fillOpacity: 0.4,
        map: mapREF.current,
        center: { lat: loc.lat, lng: loc.lng },
        radius: radius,
      });

      circlesRef.current.push(circle);
    });
  };

  const drawPolyline = (path) => {
    if (!mapREF.current || !mapsREF.current) return;

    const polyline = new mapsREF.current.Polyline({
      path,
      geodesic: true,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 2,
      fillColor: "#FFFFFF", // Fill color
      fillOpacity: 0.5, // Fill opacity (0.0 to 1.0)
    });

    polyline.setMap(mapREF.current);
  };

  const handleApiLoaded = (map, maps) => {
    mapREF.current = map;
    mapsREF.current = maps;

    //drawPolylines(myLocations);
    drawCircles(myLocations, formState.inputs.selectedDistance.value);
    drawPolyline(cankaya); // draw Çankaya outline
    return;
  };

  useEffect(() => {
    if (mapREF.current && mapsREF.current) {
      debugger;
      // Clear old circles if needed (you can track them in a ref)
      drawCircles(myLocations, formState.inputs.selectedDistance.value);
      setShowNames(formState.inputs.showNames.value);
    }
  }, [formState.inputs.selectedDistance.value, formState.inputs.showNames.value]);

  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,

      fullscreenControl: true,
      styles: [
        {
          stylers: [{ visibility: "on" }],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [{ visibility: "on" }],
        },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
      gestureHandling: "greedy",
      disableDoubleClickZoom: false,
      minZoom: 1,
      maxZoom: 25,

      mapTypeControl: false,
      mapTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: false,
    };
  };

  return (
    <React.Fragment>
      <div className="horizontal-flex" style={{ marginTop: "20px", marginBottom: "10px" }}>
        <div
          className="vertical-flex"
          style={{
            margin: "10px",
            marginLeft: "30px",
            marginBottom: "10px",

            width: "10%",
            alignItems: "center",
            flex: 1,
          }}
        >
          <h4 style={{ margin: "0", paddingBottom: "5px" }}>Yürüyüş süresi</h4>
          <CustomSelect
            options={myDistances}
            id="selectedDistance"
            initialValue={myDistances[0]}
            onInput={inputHandler}
            initialValid={true}
            // fireChange={fetchTravelActions}
          ></CustomSelect>

          <CheckBox
            id="showNames"
            label="İsimleri göster"
            initialValue={true}
            initialValid={true}
            onInput={inputHandler}
            validators={[VALIDATOR_NONE()]}
          />

          {myLocations.map((location) => {
            <div key={location.name}>
              <Input
                id="vehicle"
                element="input"
                type="text"
                label="Mevcut Araç"
                validators={[VALIDATOR_NONE()]}
                disabled={true}
                initialValue="asd"
                initialValid={true}
                onInput={inputHandler}
              />
            </div>;
          })}
        </div>

        <div style={{ width: "60%", padding: "30px", paddingLeft: "0", paddingTop: "10px", height: "80vh", flex: 6 }}>
          {myLocations.length > 0 && (
            <GoogleMapReact
              options={getMapOptions}
              key="map1"
              bootstrapURLKeys={{
                key: "AIzaSyAkGOMUyxOH98l6qetwEChfJDgzMrBiDbc",
                libraries: ["visualization"],
              }}
              heatmap={{ myLocations }}
              yesIWantToUseGoogleMapApiInternals //this is important!
              onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
              //defaultCenter={markerLocationMorning}
              defaultCenter={{
                lat: 39.8,
                lng: 32.95,
              }}
              defaultZoom={11}
            >
              {/* {locationsREF.current?.length && (
              <Marker
                Icon={DirectionsBus}
                lat={locationsREF.current[index]?.location.lat}
                lng={locationsREF.current[index]?.location.lng}
                key={"asdasggh"}
                info={myLocations[0].name}
                alwaysShowMarker={true}
                initialShow={true}
              />
            )} */}

              {/* <Marker
              Icon={SchoolIcon}
              lat={myLocations[0].lat}
              lng={myLocations[0].lng}
              key={"Okul"}
              info={myLocations[0].name}
              alwaysShowMarker={true}
            /> */}

              {myLocations.map((location) => {
                return (
                  <Marker
                    Icon={RoomIcon}
                    lat={location.lat}
                    lng={location.lng}
                    key={location.name + showNames.toString()}
                    info={location.name}
                    alwaysShowMarker={false}
                    initialShow={showNames}
                  />
                );
              })}
            </GoogleMapReact>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default WalkingDistanceCalculator;
